export default __webpack_public_path__ + "img/slogan_en.29271cf3.svg";